import { netType } from "../lib/reports";
import { canonicalProvider } from "../lib/scorecard";

export const ispLabel = (t) => canonicalProvider(t.isp) || t.isp || "Unknown";

const uniq = (arr) => [...new Set(arr.filter(Boolean))].sort();

export const applyNetFilter = (tests, { isp, net }) =>
  tests.filter((t) => (!isp || ispLabel(t) === isp) && (!net || netType(t) === net));

export const NetFilter = ({ tests, value, onChange, className = "field py-2", prefix = "" }) => {
  const isps = uniq([...tests.map(ispLabel), ...(value.isp ? [value.isp] : [])]);
  const nets = uniq(tests.map(netType));
  return (
    <>
      <select data-testid={`${prefix}isp-filter`} value={value.isp} onChange={(e) => onChange({ ...value, isp: e.target.value })} className={className}>
        <option value="">All providers</option>
        {isps.map((i) => <option key={i} value={i}>{i}</option>)}
      </select>
      <select data-testid={`${prefix}network-filter`} value={value.net} onChange={(e) => onChange({ ...value, net: e.target.value })} className={className}>
        <option value="">All networks</option>
        {nets.map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
    </>
  );
};
